import { Button } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Loader2 } from "lucide-react"

interface Props {
  onCancel: () => void
  onSave: () => void
  isPending: boolean
}

export function EditActionBar({ onCancel, onSave, isPending }: Props) {
  const { translate } = useTranslation()

  return (
    <div className="flex justify-end gap-2 px-4 pb-4">
      <Button
        size="sm"
        variant="ghost"
        className="text-grey5 hover:text-white"
        onClick={onCancel}
        disabled={isPending}
      >
        {translate("MC_MD_EDIT_CANCEL")}
      </Button>
      <Button
        size="sm"
        className="bg-yellow1 text-black hover:bg-yellow2"
        onClick={onSave}
        disabled={isPending}
      >
        {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        {translate("MC_MD_EDIT_SAVE")}
      </Button>
    </div>
  )
}
